import { AI_FIELDS } from "./aiReview";
import { parseNumber } from "./clipboardGrid";

const eq = (a, b, num) => (num ? parseNumber(a) === parseNumber(b) : String(a ?? "").trim() === String(b ?? "").trim());

// "same" | "changed" | "big" (deleted or > 10 % numeric difference)
export function fieldStatus(aiVal, cur, num) {
    if (eq(aiVal, cur, num)) return "same";
    if (cur == null || String(cur).trim() === "") return "big";
    if (num) {
        const a = parseNumber(aiVal), c = parseNumber(cur);
        if (a && c != null && Math.abs(c - a) / Math.abs(a) > 0.1) return "big";
    }
    return "changed";
}

// Builds comparison lines between one analysis and the current rows.
export function buildCompare(analysis, rows, isEmptyRow) {
    const importedIdx = new Set((analysis.imported || []).map((l) => l.idx));
    const lines = (analysis.items || []).map((it, idx) => {
        const row = rows.find((r) => r.ai_src?.aid === analysis.id && r.ai_src.idx === idx);
        const state = row ? "linked" : importedIdx.has(idx) ? "deleted" : "not_imported";
        const fields = AI_FIELDS.map((f) => {
            const ai = it[f.key]?.value ?? "";
            const cur = row ? row[f.target] : null;
            const status = !row ? (state === "deleted" ? "big" : "none") : row.edits?.[f.target]?.kept ? "kept" : fieldStatus(ai, cur, f.num);
            return { ...f, ai, cur, status, edit: row?.edits?.[f.target] || null };
        });
        return { idx, row, state, fields, page: it.page };
    });
    const manual = rows.filter((r) => !r.ai_src && !isEmptyRow(r));
    return { lines, manual };
}

export const STATUS_CLS = {
    same: "bg-emerald-500/15 text-emerald-200",
    kept: "bg-emerald-500/10 text-emerald-300",
    changed: "bg-yellow-400/20 text-yellow-100",
    big: "bg-rose-500/20 text-rose-200",
    none: "text-slate-500",
    manual: "bg-blue-500/15 text-blue-200",
};
